export const FooterConfig = [{
    key: "GitHub",
    icon: "assets/img/github-side.svg",
    url: "https://github.com/drpratik"
}, {
    key: "Linkedin",
    icon: "assets/img/linkedin.svg",
    url: "https://www.linkedin.com/in/pratik-dhore"
}, {
    key: "Insta",
    icon: "assets/img/insta.svg",
    url: "https://www.instagram.com/pratik_dhore7/"
},  {
    key: "Facebook",
    icon: "assets/img/facebook.svg",
    url: "https://www.facebook.com/pratik.dhore.50/"
}
]